// import React, { useState, useEffect, useCallback } from 'react';
// import {
//     Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer,
//     TableHead, TableRow, CircularProgress, Alert, Chip, Stack, TextField,
//     InputAdornment
// } from '@mui/material';
// import UploadFileIcon from '@mui/icons-material/UploadFile';
// import SearchIcon from '@mui/icons-material/Search';
// import Papa from 'papaparse';
// import axios from 'axios';

// const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

// const COLUMNS = [
//     { key: 'dot_number', label: 'DOT #' },
//     { key: 'legal_name', label: 'Legal Name' },
//     { key: 'dba_name', label: 'DBA Name' },
//     { key: 'phone', label: 'Phone' },
//     { key: 'cell_phone', label: 'Cell Phone' },
//     { key: 'power_units', label: 'Power Units' },
//     { key: 'docket1', label: 'Docket #' },
//     { key: 'phy_street', label: 'Street' },
//     { key: 'phy_city', label: 'City' },
//     { key: 'phy_state', label: 'State' },
//     { key: 'phy_zip', label: 'Zip' },
//     { key: 'email_address', label: 'Email' },
// ];

// /**
//  * role: 'carrier' | 'broker'  -> talks to /api/admin/csv/:role
//  * title: page heading shown above the upload button
//  */
// const CsvBulkUpload = ({ role, title }) => {
//     const [rows, setRows] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [uploading, setUploading] = useState(false);
//     const [message, setMessage] = useState(null);
//     const [error, setError] = useState(null);
//     const [rowErrors, setRowErrors] = useState([]);
//     const [search, setSearch] = useState('');

//     const authHeaders = () => {
//         const token = localStorage.getItem('jwtToken');
//         return { Authorization: `Bearer ${token}` };
//     };

//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         try {
//             const res = await axios.get(`${API_BASE}/api/admin/csv/${role}`, {
//                 headers: authHeaders()
//             });
//             setRows(res.data);
//         } catch (err) {
//             console.error(`Failed to fetch ${role} CSV data`, err);
//             setError('Failed to load existing data.');
//         } finally {
//             setLoading(false);
//         }
//     }, [role]);

//     useEffect(() => {
//         fetchData();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [fetchData]);

//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         setError(null);
//         setMessage(null);
//         setRowErrors([]);
//         setUploading(true);

//         Papa.parse(file, {
//             header: true,
//             skipEmptyLines: true,
//             complete: async (results) => {
//                 try {
//                     const parsedRows = results.data;
//                     if (!parsedRows.length) {
//                         setError('The CSV file appears to be empty.');
//                         setUploading(false);
//                         return;
//                     }

//                     const res = await axios.post(
//                         `${API_BASE}/api/admin/csv/${role}/upload`,
//                         { rows: parsedRows },
//                         { headers: authHeaders() }
//                     );

//                     setMessage(res.data.message);
//                     if (Array.isArray(res.data.errors) && res.data.errors.length > 0) {
//                         setRowErrors(res.data.errors);
//                     }
//                     await fetchData();
//                 } catch (err) {
//                     console.error(`Failed to upload ${role} CSV`, err);
//                     setError(err.response?.data?.message || 'Upload failed. Previous data was kept.');
//                 } finally {
//                     setUploading(false);
//                     e.target.value = '';
//                 }
//             },
//             error: (err) => {
//                 console.error('CSV parse error:', err);
//                 setError('Could not parse the CSV file. Please check the format.');
//                 setUploading(false);
//             }
//         });
//     };

//     const filteredRows = search.trim()
//         ? rows.filter((row) => {
//             const needle = search.trim().toLowerCase();
//             return COLUMNS.some(col =>
//                 String(row[col.key] ?? '').toLowerCase().includes(needle)
//             );
//         })
//         : rows;

//     return (
//         <Box sx={{ p: 3 }}>
//             <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }} flexWrap="wrap" gap={2}>
//                 <Box>
//                     <Typography variant="h6" fontWeight="bold">{title}</Typography>
//                     <Typography variant="body2" color="text.secondary">
//                         Uploading a new CSV permanently replaces all previously stored {role} records.
//                     </Typography>
//                 </Box>
//                 <Button
//                     variant="contained"
//                     component="label"
//                     startIcon={<UploadFileIcon />}
//                     disabled={uploading}
//                 >
//                     {uploading ? 'Uploading...' : `Upload ${role} CSV`}
//                     <input type="file" accept=".csv" hidden onChange={handleFileChange} />
//                 </Button>
//             </Stack>

//             {uploading && <Alert severity="info" sx={{ mb: 2 }}>Replacing previous data and inserting new rows, please wait…</Alert>}
//             {message && <Alert severity="success" sx={{ mb: 2 }} onClose={() => setMessage(null)}>{message}</Alert>}
//             {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>{error}</Alert>}
//             {rowErrors.length > 0 && (
//                 <Alert severity="warning" sx={{ mb: 2 }} onClose={() => setRowErrors([])}>
//                     {rowErrors.length} row(s) were skipped (e.g. missing legal name / DOT number). Everything else uploaded fine.
//                 </Alert>
//             )}

//             <Paper variant="outlined">
//                 <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
//                     <Typography variant="subtitle2">
//                         Current Records:{' '}
//                         <Chip label={rows.length} size="small" color="primary" />
//                     </Typography>
//                     <TextField
//                         size="small"
//                         placeholder="Search loaded records..."
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <SearchIcon fontSize="small" />
//                                 </InputAdornment>
//                             )
//                         }}
//                         sx={{ width: 260 }}
//                     />
//                 </Box>
//                 {loading ? (
//                     <Box sx={{ p: 4, textAlign: 'center' }}><CircularProgress size={28} /></Box>
//                 ) : rows.length === 0 ? (
//                     <Box sx={{ p: 4, textAlign: 'center' }}>
//                         <Typography color="text.secondary">No data uploaded yet.</Typography>
//                     </Box>
//                 ) : (
//                     <TableContainer sx={{ maxHeight: 600 }}>
//                         <Table stickyHeader size="small">
//                             <TableHead>
//                                 <TableRow>
//                                     {COLUMNS.map(col => (
//                                         <TableCell key={col.key} sx={{ fontWeight: 'bold' }}>{col.label}</TableCell>
//                                     ))}
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {filteredRows.map((row) => (
//                                     <TableRow key={row.id} hover>
//                                         {COLUMNS.map(col => (
//                                             <TableCell key={col.key}>{row[col.key] ?? '-'}</TableCell>
//                                         ))}
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 )}
//             </Paper>
//         </Box>
//     );
// };

// export default CsvBulkUpload;


import React, { useState, useEffect, useCallback } from 'react';
import {
    Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, CircularProgress, Alert, Chip, Stack, TextField,
    InputAdornment, Container, ThemeProvider, createTheme, Collapse, Card,
    CardContent, Divider
} from '@mui/material';
import { styled } from '@mui/material/styles';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SearchIcon from '@mui/icons-material/Search';
import Papa from 'papaparse';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

const theme = createTheme({
    palette: {
        primary: { main: '#11224d' },
        secondary: { main: '#E1AD01' },
        background: { default: '#f3f4f6', paper: '#fff' },
    },
    typography: { fontSize: 12 },
});

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1.5),
    backgroundColor: '#fff',
    borderRadius: theme.spacing(1),
}));

const StyledCard = styled(Card)(({ theme }) => ({
    marginTop: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    border: '1px solid #e0e0e0',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
}));

// Same formatting rules used in DirectorySearch / FavoritesViewer
const formatEmail = (email) => (email ? String(email).trim().toLowerCase() : '');

const formatCity = (city) => {
    if (!city) return '';
    const trimmed = String(city).trim().toLowerCase();
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};

const formatDocket = (docket) => {
    if (!docket) return '';
    const digitsOnly = String(docket).replace(/[^0-9]/g, '');
    return digitsOnly ? `MC ${digitsOnly}` : String(docket);
};

const telHref = (phone) => {
    if (!phone) return '';
    const digits = String(phone).replace(/[^0-9+]/g, '');
    return `tel:${digits}`;
};

const ctaLinkSx = {
    color: '#3B82F6', // light blue
    textDecoration: 'none',
    fontWeight: 500,
    '&:hover': { textDecoration: 'underline' },
};

// Header columns shown collapsed — everything else lives in the expanded detail card.
const HEADER_COLUMNS = [
    { key: 'dot_number', label: 'DOT #', width: 100 },
    { key: 'legal_name', label: 'Legal Name', width: 260 },
    { key: 'phone', label: 'Phone', width: 150 },
    { key: 'email_address', label: 'Email', width: 240 },
];

// Used for the search filter so it still checks every underlying field, including fax.
const SEARCHABLE_KEYS = [
    'dot_number', 'legal_name', 'dba_name', 'phone', 'cell_phone', 'fax',
    'power_units', 'docket1', 'phy_street', 'phy_city', 'phy_state', 'phy_zip',
    'email_address'
];

const DetailSection = ({ title, children }) => (
    <Box sx={{ pr: 2 }}>
        <Typography
            variant="subtitle2"
            sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#11224d', mb: 0.5 }}
        >
            {title}
        </Typography>
        {children}
    </Box>
);

function CsvRow({ row }) {
    const [open, setOpen] = useState(false);

    const email = formatEmail(row.email_address);
    const city = formatCity(row.phy_city);
    const docket = formatDocket(row.docket1);

    return (
        <>
            <TableRow
                hover
                onClick={() => setOpen(!open)}
                sx={{
                    cursor: 'pointer',
                    '& td': { position: 'relative' },
                    '& td:not(:last-child)::after': {
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        top: '25%',
                        height: '50%',
                        borderRight: '1px solid #ddd',
                    },
                }}
            >
                <TableCell sx={{ textAlign: 'center' }}>{row.dot_number ?? '-'}</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>{row.legal_name ?? '-'}</TableCell>
                <TableCell sx={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                    {row.phone ? (
                        <a href={telHref(row.phone)} style={ctaLinkSx}>{row.phone}</a>
                    ) : '-'}
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                    {email ? (
                        <a href={`mailto:${email}`} style={ctaLinkSx}>{email}</a>
                    ) : '-'}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <StyledCard>
                            <CardContent sx={{ p: 1.5 }}>
                                <Typography
                                    variant="body1"
                                    sx={{ fontWeight: 'bold', mb: 1, fontSize: '1rem', color: '#11224d' }}
                                >
                                    {row.legal_name || 'Unnamed Company'}
                                </Typography>
                                <Divider sx={{ my: 1 }} />

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mt: 1, flexWrap: 'wrap' }}>
                                    <Box sx={{ flex: 1, minWidth: 200, pr: 2, mb: 2 }}>
                                        <DetailSection title="Company">
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>DBA Name:</span>{' '}
                                                {row.dba_name || '-'}
                                            </Typography>
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>DOT Number:</span>{' '}
                                                {row.dot_number || '-'}
                                            </Typography>
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>Docket #:</span>{' '}
                                                {docket || '-'}
                                            </Typography>
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>Power Units:</span>{' '}
                                                {row.power_units ?? '-'}
                                            </Typography>
                                        </DetailSection>
                                    </Box>

                                    <Box sx={{ flex: 1, minWidth: 200, pr: 2, mb: 2 }}>
                                        <DetailSection title="Contact">
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>Phone:</span>{' '}
                                                {row.phone ? (
                                                    <a href={telHref(row.phone)} style={ctaLinkSx}>{row.phone}</a>
                                                ) : '-'}
                                            </Typography>
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>Cell Phone:</span>{' '}
                                                {row.cell_phone ? (
                                                    <a href={telHref(row.cell_phone)} style={ctaLinkSx}>{row.cell_phone}</a>
                                                ) : '-'}
                                            </Typography>
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>Fax:</span>{' '}
                                                {row.fax || '-'}
                                            </Typography>
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>Email:</span>{' '}
                                                {email ? (
                                                    <a href={`mailto:${email}`} style={ctaLinkSx}>{email}</a>
                                                ) : '-'}
                                            </Typography>
                                        </DetailSection>
                                    </Box>

                                    <Box sx={{ flex: 1, minWidth: 200, mb: 2 }}>
                                        <DetailSection title="Location">
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>Street:</span>{' '}
                                                {row.phy_street || '-'}
                                            </Typography>
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>City:</span>{' '}
                                                {city || '-'}
                                            </Typography>
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>State:</span>{' '}
                                                {row.phy_state || '-'}
                                            </Typography>
                                            <Typography variant="body2">
                                                <span style={{ fontWeight: 'bold' }}>Zip:</span>{' '}
                                                {row.phy_zip || '-'}
                                            </Typography>
                                        </DetailSection>
                                    </Box>
                                </Box>
                            </CardContent>
                        </StyledCard>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

/**
 * role: 'carrier' | 'broker'  -> talks to /api/admin/csv/:role
 * title: page heading shown above the upload button
 */
const CsvBulkUpload = ({ role, title }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [rowErrors, setRowErrors] = useState([]);
    const [search, setSearch] = useState('');

    const authHeaders = () => {
        const token = localStorage.getItem('jwtToken');
        return { Authorization: `Bearer ${token}` };
    };

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${API_BASE}/api/admin/csv/${role}`, {
                headers: authHeaders()
            });
            setRows(res.data);
        } catch (err) {
            console.error(`Failed to fetch ${role} CSV data`, err);
            setError('Failed to load existing data.');
        } finally {
            setLoading(false);
        }
    }, [role]);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setError(null);
        setMessage(null);
        setRowErrors([]);
        setUploading(true);

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: async (results) => {
                try {
                    const parsedRows = results.data;
                    if (!parsedRows.length) {
                        setError('The CSV file appears to be empty.');
                        setUploading(false);
                        return;
                    }

                    const res = await axios.post(
                        `${API_BASE}/api/admin/csv/${role}/upload`,
                        { rows: parsedRows },
                        { headers: authHeaders() }
                    );

                    setMessage(res.data.message);
                    if (Array.isArray(res.data.errors) && res.data.errors.length > 0) {
                        setRowErrors(res.data.errors);
                    }
                    await fetchData();
                } catch (err) {
                    console.error(`Failed to upload ${role} CSV`, err);
                    setError(err.response?.data?.message || 'Upload failed. Previous data was kept.');
                } finally {
                    setUploading(false);
                    e.target.value = '';
                }
            },
            error: (err) => {
                console.error('CSV parse error:', err);
                setError('Could not parse the CSV file. Please check the format.');
                setUploading(false);
            }
        });
    };

    const filteredRows = search.trim()
        ? rows.filter((row) => {
            const needle = search.trim().toLowerCase();
            return SEARCHABLE_KEYS.some(key =>
                String(row[key] ?? '').toLowerCase().includes(needle)
            );
        })
        : rows;

    return (
        <ThemeProvider theme={theme}>
            <style>
                {`
                  html, body, #root {
                    margin: 0;
                    padding: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                `}
            </style>
            <Box
                sx={{
                    backgroundColor: '#f3f4f6',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                }}
            >
                <Container
                    maxWidth="xl"
                    disableGutters
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        height: '100%',
                        overflow: 'hidden',
                        pl: 1,
                        pr: 1,
                        mt: 0,
                    }}
                >
                    <StyledPaper elevation={1} sx={{ mt: 1, mb: 0 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                            <Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#11224d' }}>
                                    {title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Uploading a new CSV permanently replaces all previously stored {role} records.
                                </Typography>
                            </Box>
                            <Button
                                variant="contained"
                                component="label"
                                startIcon={<UploadFileIcon />}
                                disabled={uploading}
                                sx={{
                                    backgroundColor: '#11224d',
                                    color: 'white',
                                    fontSize: '0.8rem',
                                    py: 1,
                                    px: 2,
                                    '&:hover': { backgroundColor: '#0e1d3a' },
                                    '&.Mui-disabled': { backgroundColor: '#ccc', color: '#666' },
                                }}
                            >
                                {uploading ? 'Uploading...' : `Upload ${role} CSV`}
                                <input type="file" accept=".csv" hidden onChange={handleFileChange} />
                            </Button>
                        </Stack>

                        {uploading && <Alert severity="info" sx={{ mt: 2 }}>Replacing previous data and inserting new rows, please wait…</Alert>}
                        {message && <Alert severity="success" sx={{ mt: 2 }} onClose={() => setMessage(null)}>{message}</Alert>}
                        {error && <Alert severity="error" sx={{ mt: 2 }} onClose={() => setError(null)}>{error}</Alert>}
                        {rowErrors.length > 0 && (
                            <Alert severity="warning" sx={{ mt: 2 }} onClose={() => setRowErrors([])}>
                                {rowErrors.length} row(s) were skipped (e.g. missing legal name / DOT number). Everything else uploaded fine.
                            </Alert>
                        )}
                    </StyledPaper>

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            px: 2,
                            py: 1,
                            borderTop: '1px solid #e0e0e0',
                            borderBottom: '1px solid #e0e0e0',
                            backgroundColor: '#f9fafc',
                            flexWrap: 'wrap',
                            gap: 1,
                        }}
                    >
                        <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '0.9rem' }}>
                            Current Records:{' '}
                            <Chip label={rows.length} size="small" color="primary" />
                        </Typography>
                        <TextField
                            size="small"
                            placeholder="Search loaded records..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                )
                            }}
                            sx={{ width: 260, background: '#fff' }}
                        />
                    </Box>

                    {loading ? (
                        <Box sx={{ p: 4, textAlign: 'center' }}>
                            <CircularProgress size={28} />
                        </Box>
                    ) : rows.length === 0 ? (
                        <Box sx={{ p: 4, textAlign: 'center' }}>
                            <Typography color="text.secondary">No data uploaded yet.</Typography>
                        </Box>
                    ) : (
                        <Box sx={{ flexGrow: 1, overflow: 'auto', maxHeight: 'calc(100vh - 260px)' }}>
                            <TableContainer component={Paper} sx={{ maxHeight: '100%', overflowX: 'auto', overflowY: 'auto' }}>
                                <Table
                                    size="small"
                                    sx={{
                                        tableLayout: 'fixed',
                                        '& .MuiTableCell-root': {
                                            padding: '7px 11px',
                                            fontSize: '0.7rem',
                                            lineHeight: 1.2,
                                        },
                                    }}
                                >
                                    <TableHead sx={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#11224d' }}>
                                        <TableRow>
                                            {HEADER_COLUMNS.map(col => (
                                                <TableCell
                                                    key={col.key}
                                                    sx={{
                                                        backgroundColor: '#11224d',
                                                        color: 'white',
                                                        fontSize: '0.85rem',
                                                        fontWeight: 'bold',
                                                        padding: '6px 10px',
                                                        whiteSpace: 'nowrap',
                                                        width: col.width,
                                                        maxWidth: col.width,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        textAlign: 'center',
                                                        borderBottom: 'none',
                                                    }}
                                                >
                                                    {col.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredRows.map((row) => (
                                            <CsvRow key={row.id} row={row} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    )}
                </Container>
            </Box>
        </ThemeProvider>
    );
};

export default CsvBulkUpload;